import { http } from "../../core/http";
import {
  downloadBlobResponse,
  handleBlobExportError,
} from "../../core/download";
import { normalizePaginatedResponse } from "../../core/response";
import type {
  AddFreightRevenuePayload,
  ConfirmImportFreightRevenuePayload,
  CustomerQueryParams,
  UpdateFreightRevenuePayload,
  UpdateFreightRevenueVersionPayload,
} from "./types";

const getFreightVesion = async (params: Record<string, unknown>) => {
  const response = await http
    .get("admin/freight/version", { params })
    .then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "page");
  }
};

const getAllFreight = async (params: Record<string, unknown>) => {
  const response = await http
    .get("admin/freight", { params })
    .then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "page");
  }
};

const postAddFreightRevenue = async (payload: AddFreightRevenuePayload) => {
  const response = await http
    .post("admin/freight", payload)
    .then((res) => res.data);
  return response;
};

const putUpdateFreightRevenue = async (
  payload: UpdateFreightRevenuePayload,
  id: string,
  params?: Record<string, unknown>,
) => {
  const response = await http
    .put(`admin/freight/${id}`, payload, { params })
    .then((res) => res.data);
  return response;
};

const getAllCustomer = async (params: CustomerQueryParams) => {
  const response = await http
    .get("/admin/customer", {
      params,
      silentLoading: Boolean(params.searchText),
    })
    .then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "page");
  }
};

const postPreCheckImportFreight = async (file: Blob) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await http
    .post("/admin/freight/import/pre-check", formData)
    .then((res) => res.data);
  return response;
};

const postConfirmImportFreight = async (
  payload: ConfirmImportFreightRevenuePayload,
) => {
  const response = await http.post("/admin/freight/import/confirm", payload);
  return response.data;
};

const getExportVersion = async (id: string, name: string) => {
  try {
    const response = await http.get("/admin/freight/export", {
      params: { versionId: id },
      responseType: "blob",
      silent: true,
      silentLoading: true,
    });

    return downloadBlobResponse(response, `Cước doanh thu ${name}.xlsx`);
  } catch (error: unknown) {
    await handleBlobExportError(error);
    throw error;
  }
};

const shortDeleteFreightRevenue = async (payload: { ids: string[] }) => {
  const response = await http.put("/admin/freight/delete", payload);
  return response.data;
};

export const putUpdateFreightRevenueVersion = async (
  payload: UpdateFreightRevenueVersionPayload,
  id: string,
) => {
  const response = await http.put(`/admin/freight/version/${id}`, payload);
  return response.data;
};

export const applyFreightRevenueVersionToOrders = async (
  versionId: string,
) => {
  const response = await http.post(
    `/admin/freight/version/${versionId}/apply-orders`,
  );
  return response.data;
};

export default {
  getFreightVesion,
  getAllFreight,
  postAddFreightRevenue,
  putUpdateFreightRevenue,
  getAllCustomer,
  postPreCheckImportFreight,
  postConfirmImportFreight,
  getExportVersion,
  shortDeleteFreightRevenue,
  putUpdateFreightRevenueVersion,
  applyFreightRevenueVersionToOrders,
};
